import { PhotoThemes, AppHeader } from '../components'
import { Camera, Upload, ExternalLink, AlertCircle } from 'lucide-react'
import { Helmet } from 'react-helmet-async'
import ProtectedRoute from '../components/auth/ProtectedRoute'
import { config } from '../config/environment'

export default function PhotosPage() {
  return (
    <ProtectedRoute>
      <Helmet>
        <title>Photos - FWO Pilot Portal</title>
        <meta name="description" content="Photo competition - submit themed photos and view gallery" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <AppHeader activePage="photos" />

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="bg-green-100 p-2 rounded-lg">
                  <Camera className="h-6 w-6 text-green-600" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">Photo Competition</h1>
                  <p className="text-gray-600">Submit daily themed photos and view the competition gallery</p>
                </div>
              </div>

              {/* Gallery link */}
              {config.galleryUrl ? (
                <a
                  href={config.galleryUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors"
                >
                  <ExternalLink className="h-4 w-4" />
                  View Gallery
                </a>
              ) : (
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-400 text-sm font-medium rounded-lg cursor-not-allowed" title="Gallery not configured for this environment">
                  <AlertCircle className="h-4 w-4" />
                  Gallery unavailable
                </div>
              )}
            </div>
          </div>

          {/* Photo Themes */}
          <PhotoThemes />

          {/* Submission guidelines */}
          <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start">
              <Upload className="h-5 w-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-blue-900 mb-1">Photo Submission Guidelines</h3>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• You can submit one photo per theme per day</li>
                  <li>• Accepted formats: JPG, PNG, HEIC (max 10MB)</li>
                  <li>• Photos are reviewed before being published in the gallery</li>
                  <li>• Drag and drop files or click "Upload Photo" to select</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  )
}